import React, {useState} from "react";
import {InputNumber} from "antd";
import {useTranslation} from "react-i18next";
import {numericInputProps} from "utils/helpers";
import {
    SelectionCard,
    SelectionTitle,
    CourierCountContainer
} from "../style/CustomerRequestsPage.styles";
import {VFlex} from "components/_defaultComponents/Flex/VFlex";
import {VText} from "components/_defaultComponents/Text/VText";

const CourierPackageCountInput = ({
    courierCount,
    setCourierCount,
    packageCount,
    setPackageCount,
    isActive
}) => {
    const {t} = useTranslation();
    const [courierError, setCourierError] = useState("");
    const [packageError, setPackageError] = useState("");

    const handleCourierChange = value => {
        setCourierCount(value);
        if (value !== null && value !== undefined && (value < 1 || value > 10)) {
            setCourierError(t("screens.customerRequests.courierCountMustBeBetween1And10"));
        } else {
            setCourierError("");
        }
    };

    const handlePackageChange = value => {
        setPackageCount(value);
        if (value !== null && value !== undefined && value < 1) {
            setPackageError(t("screens.customerRequests.pleaseEnterValidPackageCount"));
        } else {
            setPackageError("");
        }
    };

    return (
        <SelectionCard $disabled={!isActive}>
            <SelectionTitle>3. {t("screens.customerRequests.courierPackageCount")}</SelectionTitle>
            <CourierCountContainer style={{marginBottom: "16px"}}>
                <label style={{fontWeight: 500, fontSize: "14px"}}>
                    {t("screens.customerRequests.requestedCourierCount")}
                </label>
                <VFlex vertical>
                    <InputNumber
                        value={courierCount}
                        onChange={handleCourierChange}
                        placeholder={t("screens.customerRequests.enterCount")}
                        style={{width: "100px", marginLeft: "12px"}}
                        disabled={!isActive}
                        min={0}
                        {...numericInputProps}
                    />
                    {courierError && (
                        <VText
                            style={{
                                color: "#ff4d4f",
                                fontSize: "12px",
                                marginTop: "4px",
                                marginLeft: "12px"
                            }}
                        >
                            {courierError}
                        </VText>
                    )}
                </VFlex>
            </CourierCountContainer>
            <CourierCountContainer>
                <label style={{fontWeight: 500, fontSize: "14px"}}>
                    {t("screens.customerRequests.requestedPackageCount")}
                </label>
                <VFlex vertical>
                    <InputNumber
                        value={packageCount}
                        onChange={handlePackageChange}
                        placeholder={t("screens.customerRequests.enterCount")}
                        style={{width: "100px", marginLeft: "12px"}}
                        disabled={!isActive}
                        min={0}
                        {...numericInputProps}
                    />
                    {packageError && (
                        <VText
                            style={{
                                color: "#ff4d4f",
                                fontSize: "12px",
                                marginTop: "4px",
                                marginLeft: "12px"
                            }}
                        >
                            {packageError}
                        </VText>
                    )}
                </VFlex>
            </CourierCountContainer>
        </SelectionCard>
    );
};

export default CourierPackageCountInput;
